import axios from "axios";
import { ElMessage } from "element-plus";
axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  (response) => response,
  function (error) {
    console.log(error.response);
    ElMessage.error({
      message: error.response.data.message,
      customClass: "break-line",
    });
    return Promise.reject(error);
  }
);
export { axios };
